import { useCallback, useEffect, useState } from 'react'
import { useExternalStyles } from './useExternalStyles'

export enum TenantUuid {
  Smava = 'f9343d8a-4bd3-48b8-a504-e99f102f463c',
  FinanzcheckShared = '2245defb-94aa-4c24-9bb1-ce9c06e097f8',
  FinanzcheckStage = '744e3a15-6238-4c2e-9c39-8411cf2b6a1b',
  FinanzcheckLive = 'de0b41bd-175b-4b13-adf8-eef7450bf698',
}
class FintecThemeError extends Error {
  constructor(error: Error, tenantUuid: TenantUuid) {
    super(
      `Error loading theme for tenantUuid ${tenantUuid} \n Error: ${error.message}`,
    )

    this.name = 'FintecThemeError'
  }
}

const xs2aStylesheets: Array<HTMLLinkElement['href']> = [
  'https://api.xs2a.com/xs2a.css',
  'https://api.xs2a.com/xs2a-responsive.css',
]

const loadFinanzcheckTheme = () => import('../themes/finanzcheck.css')
const loadSmavaTheme = () => import('../themes/smava.css')

const themeMapping = {
  [TenantUuid.FinanzcheckShared]: loadFinanzcheckTheme,
  [TenantUuid.FinanzcheckStage]: loadFinanzcheckTheme,
  [TenantUuid.FinanzcheckLive]: loadFinanzcheckTheme,
  [TenantUuid.Smava]: loadSmavaTheme,
}

interface useThemesParam {
  clientUuid: TenantUuid
}

export const useTheme = ({ clientUuid }: useThemesParam) => {
  const { isLoading: areBaseStylesLoading } = useExternalStyles(xs2aStylesheets)
  const [isLoading, setLoading] = useState(true)

  const loadTheCssFile = useCallback(async () => {
    try {
      const loadTheme = themeMapping[clientUuid]
      if (!loadTheme) {
        return
      }
      await loadTheme()
    } catch (error) {
      throw new FintecThemeError(error as Error, clientUuid)
    } finally {
      setLoading(false)
    }
  }, [clientUuid])

  useEffect(() => {
    loadTheCssFile()
  }, [loadTheCssFile])

  return { isThemeLoaded: !areBaseStylesLoading && !isLoading }
}
